import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import noop from 'lodash/noop';
import { Spotlight as AkSpotlight } from '@atlaskit/onboarding';
import { buttonActionTypes } from '../../common/types/button';
import HtmlContent from '../../controllers/utils/html-content';
// eslint-disable-next-line @repo/internal/react/no-class-components
export default class EngagementSpotlight extends Component {
  getButtonClickHandler(buttonType, action) {
    const {
      fireClickEvent
    } = this.props;
    switch (action.type) {
      case buttonActionTypes.LINK:
        return () => {
          fireClickEvent(`${buttonType}`);
          window.open(action.data.url, action.data.target);
        };
      default:
        return () => {
          fireClickEvent(`${buttonType}`);
        };
    }
  }
  getButtonActions() {
    const {
      primaryAction,
      primaryText,
      secondaryAction,
      secondaryText
    } = this.props;
    const actions = [];
    if (secondaryAction && secondaryText) {
      actions.push({
        onClick: this.getButtonClickHandler('secondary', secondaryAction),
        text: secondaryText,
        appearance: secondaryAction.appearance
      });
    }
    if (primaryAction && primaryText) {
      actions.push({
        onClick: this.getButtonClickHandler('primary', primaryAction),
        text: primaryText,
        appearance: primaryAction.appearance,
        autoFocus: true
      });
    }
    return actions;
  }
  render() {
    const {
      body,
      dialogPlacement,
      dialogWidth,
      title,
      image,
      pulse,
      target,
      targetBgColor,
      targetRadius
    } = this.props;
    return /*#__PURE__*/React.createElement(AkSpotlight, {
      actions: this.getButtonActions(),
      dialogPlacement: dialogPlacement,
      dialogWidth: dialogWidth,
      heading: title,
      image: image,
      pulse: pulse,
      target: target,
      targetBgColor: targetBgColor,
      targetRadius: targetRadius
    }, /*#__PURE__*/React.createElement(HtmlContent, {
      html: body
    }));
  }
}
_defineProperty(EngagementSpotlight, "defaultProps", {
  fireClickEvent: noop
});